import { render, staticRenderFns } from "./ProductStockList.vue?vue&type=template&id=a29a19b2&scoped=true"
import script from "./ProductStockList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductStockList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductStockList.vue?vue&type=style&index=0&id=a29a19b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29a19b2",
  null
  
)

export default component.exports